<template>
    <v-app>
        <slot name="menu" />

        <slot name="principal" />


        <Confirm ref="confirm" />

        <Login
            v-if="showLoginDialog"
            @login="onLogin"
            @close="showLoginDialog = false"
        />

        <MyAccount
            v-if="showMyAccountDialog"
            :initial-tab="myAccountTab"
            @close="showMyAccountDialog = false"
        />

        <v-snackbar
            v-model="snackbar.show"
            :timeout="2500"
            centered
            elevation="12"
            fixed
            top
            :color="snackbar.type == 'success' ? 'green accent-4' : 'error'"
        >
            <span>
                <v-icon color="white">
                    mdi-{{ snackbar.type === 'success' ? 'check-circle-outline' : 'close-circle-outline' }}
                </v-icon>
                {{ snackbar.text }}
            </span>
        </v-snackbar>
    </v-app>
</template>

<script>
import Confirm from './Confirm';
import Login from '@/pages/auth/Login';
import MyAccount from '@/pages/auth/MyAccount';

export default {
    name: 'BaseContainer',

    components: {
        Confirm,
        Login,
        MyAccount,
    },

    data: () => ({
        snackbar: {show: false, text: '', type: ''},
        showLoginDialog: false,
        showMyAccountDialog: false,
        myAccountTab: 0,
    }),

    mounted() {
        this.$root.$on('notify', data => (this.setSnackbar(data)));
        this.$root.$on('login', () => (this.showLoginDialog = true));
        this.$root.$on('myAccount', (opts) => {
            const abas = { dados: 0, enderecos: 1, pedidos: 2 };
            this.myAccountTab = (opts && abas[opts.tab] != null) ? abas[opts.tab] : 0;
            this.showMyAccountDialog = true;
        });

        this.$root.$confirm = this.$refs.confirm.open;
    },

    methods: {
        setSnackbar(data) {
            data.show = true;
            this.snackbar = data;
        },

        onLogin() {
            this.showLoginDialog = false;
            this.notify(this.$t('envio.avisos.loginSucesso'));
        },
    }
};
</script>

<style scoped>
.v-card__text {
    padding: 6px !important;
}
</style>